import { create } from 'zustand';
import { useMessagesStore } from './messagesStore';
import { ApiUtils } from '@shared/utils';
import { MessagesApi, StoreBaseReturn, type SendMessageRequest } from '@shared/api';

interface UseSendMessageStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  sendMessage: (data: Omit<SendMessageRequest, 'Id'>, reRequest?: boolean, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useSendMessageStore = create<UseSendMessageStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  sendMessage: async (data, reRequest, signal) => {
    try {
      set({ loading: true, error: null, data: false });
      const Id = crypto.randomUUID();
      await MessagesApi.sendMessage({ ...data, Id }, signal);
      reRequest && useMessagesStore.getState().getMessages('outgoing');
      set({ data: true, loading: false });
      return { loading: false, data: true };
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, error: null, data: false }),
}));
